import React, { useState, useEffect, createContext, useContext } from 'react';
import PageHeader from '../components/shared/PageHeader';
import { getDashboardStatistics } from '../../utils/apiHelper';

import AlertCards from './AlertCards';
import KpiCards from './KpiCards';
import RevenueChart from './RevenueChart';
import DeliveryStatus from './DeliveryStatus';
import PendingOrders from './PendingOrders';
import RecentActivity from './RecentActivity';
import TopProducts from './TopProducts';
import CustomerSummary from './CustomerSummary';

import '../styles/Dashboard.css';

// Shared data context to avoid duplicate API calls
export const DashboardDataContext = createContext({});

export const useDashboardData = () => useContext(DashboardDataContext);

const Dashboard = () => {
  const [sharedData, setSharedData] = useState({});

  // Fetch endpoints that are used by multiple components once
  useEffect(() => {
    const loadShared = async () => {
      try {
        const [chartsRes, customersRes, deliveriesRes] = await Promise.all([
          getDashboardStatistics.charts(),
          getDashboardStatistics.customers(),
          getDashboardStatistics.deliveries()
        ]);
        setSharedData({
          charts: chartsRes?.success ? chartsRes.statistics : null,
          customers: customersRes?.success ? customersRes.statistics : null,
          deliveries: deliveriesRes?.success ? deliveriesRes.statistics : null
        });
      } catch (err) {
        console.error('Dashboard shared data error:', err);
      }
    };
    loadShared();
  }, []);

  return (
    <DashboardDataContext.Provider value={sharedData}>
      <div>
        <PageHeader
          title="Dashboard"
          description="İşletmenizin genel durumu ve dikkat gerektiren öğeler"
          breadcrumbs={[
            { label: 'Admin', path: '/admin' },
            { label: 'Dashboard' }
          ]}
        />

        {/* Section 1: Dikkat Gerektiren */}
        <AlertCards />

        {/* Section 2: Performans KPI'ları */}
        <KpiCards />

        {/* Section 3: Operasyonel (aksiyon gerektiren) */}
        <div className="dashboard-section">
          <div className="dashboard-section-title">
            <i className="fas fa-tasks"></i> Operasyonel Durum
          </div>
          <div className="detail-panels-grid">
            <PendingOrders />
            <DeliveryStatus />
          </div>
        </div>

        {/* Section 4: Trend & Analiz */}
        <div className="dashboard-section">
          <div className="dashboard-section-title">
            <i className="fas fa-chart-bar"></i> Trend & Analiz
          </div>
          <div className="detail-panels-grid">
            <RevenueChart />
            <TopProducts />
          </div>
        </div>

        {/* Section 5: Müşteri & Aktivite */}
        <div className="dashboard-section">
          <div className="dashboard-section-title">
            <i className="fas fa-users"></i> Müşteri & Aktivite
          </div>
          <div className="detail-panels-grid">
            <CustomerSummary />
            <RecentActivity />
          </div>
        </div>
      </div>
    </DashboardDataContext.Provider>
  );
};

export default Dashboard;
